export function getTournamentVoterId() {
  const storageKey = "tournamentVoterId";
  const existing = localStorage.getItem(storageKey);

  if (existing) {
    return existing;
  }

  const created = `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
  localStorage.setItem(storageKey, created);
  return created;
}
